import _get from 'lodash.get';
import React from 'react';
import { Helmet } from "react-helmet"
class CustomHelmet extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
        };
    }
    componentDidMount() {
        if (document) {
            this.setState({ url: document.location.href });
        }
    }
    brightnessByColor(colorInput) {
        var color = "" + colorInput;
        //console.log(colorInput);
        var m = color.substr(1).match(color.length == 7 ? /(\S{2})/g : /(\S{1})/g);
        if (m) var r = parseInt(m[0], 16), g = parseInt(m[1], 16), b = parseInt(m[2], 16);

        if (typeof r != "undefined") return ((r * 299) + (g * 587) + (b * 114)) / 1000;
    }
    render() {
        let { siteSeo, pageSeo, image, backgroundColor, textColor, twitterCard = 'summary_large_image' } = this.props;
        const description = _get(
            pageSeo,
            'description',
            _get(siteSeo, 'fallbackSeo.description', '')
        );
        let title = _get(pageSeo, 'title', '');
        if (title != '') {
            title = title + _get(siteSeo, 'titleSuffix', '');
        } else {
            title = _get(siteSeo, 'fallbackTitle', '');
        }
        let seoImage = _get(pageSeo, 'image', '');
        if (image == null) {
            image = seoImage;
        }
        let invertCursor = false;
        if (backgroundColor) {
            if (this.brightnessByColor(backgroundColor) < 100) {
                invertCursor = true;
            }
        }
        return (
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta name="image" content={image && image.url} />
                <link rel="canonical" href={this.state.url} />

                <meta name="pinterest" content="nopin" />
                <meta name="format-detection" content="telephone=no" />
                {/* OpenGraph tags */}
                <meta property="og:type" content="article" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                {image && <meta property="og:image" content={image.url} />}
                {image && <meta property="og:image:width" content={image.width} />}
                {image && <meta property="og:image:height" content={image.height} />}
                <meta property="og:url" content={this.state.url} />

                {/* Twitter Card tags */}
                <meta name="twitter:card" content={twitterCard} />
                <meta name="twitter:title" content={title} />
                <meta name="twitter:description" content={description} />
                {image && <meta name="twitter:image" content={image.url} />}
                <meta name="twitter:site" content="@kontrapunktcom" />
                <meta name="twitter:creator" content="@kontrapunktcom" />
                <body className={invertCursor ? 'invert-fallback' : ''} />
                <style>{`body { background-color: ${backgroundColor}; }`}</style>
            </Helmet>
        );
    }
}

export default CustomHelmet;
